import React from 'react';
const MessageBubble = ({ displayName, isLocal, message, timestamp }) => {
    const time = new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: isLocal ? 'flex-end' : 'flex-start',
            marginBottom: '12px',
            padding: '0 16px'
        } },
        !isLocal && (React.createElement("span", { style: {
                fontSize: '10px',
                fontWeight: 600,
                letterSpacing: '0.8px',
                textTransform: 'uppercase',
                color: 'rgba(239,229,220,0.55)',
                marginBottom: '4px'
            } }, displayName)),
        React.createElement("div", { style: {
                maxWidth: '78%',
                padding: '10px 14px',
                background: isLocal ? '#440A1C' : 'rgba(255,255,255,0.08)',
                color: '#EFE5DC',
                borderRadius: isLocal
                    ? '16px 16px 4px 16px'
                    : '16px 16px 16px 4px',
                fontSize: '14px',
                lineHeight: 1.55,
                wordBreak: 'break-word'
            } },
            message,
            React.createElement("div", { style: {
                    fontSize: '10px',
                    opacity: 0.4,
                    marginTop: '6px',
                    textAlign: isLocal ? 'right' : 'left'
                } }, time))));
};
export default MessageBubble;
